let elements = {
  mainImage: {
    imagePath: 'games/page001_game1/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  fields: [
    {
      pos: {
        y: 270,
        x: 705,
      },
      width: 74,
      height: 74,
      background: 'transparent',
      // cssStyle: { 'border-radius': '30px', border: 'solid 5px #3a5f8b' },
      audio: {
        src: 'games/page001_game1/audio/z1c1_1.mp3',
        volume: 1,
      },
      // text: {
      //   text: 'Zachowuj porządek podczas pracy przy komputerze.',
      //   pos: {
      //     y: 343,
      //     x: 25,
      //   },
      //   width: 500,
      //   background: '#4f81bd',
      //   cssStyle: { 'border-radius': '30px', border: 'solid 5px #3a5f8b' },
      // },
    },
    {
      pos: {
        y: 270,
        x: 1079,
      },
      width: 74,
      height: 74,
      background: 'transparent',
      // cssStyle: { 'border-radius': '30px', border: 'solid 5px #c27537' },
      audio: {
        src: 'games/page001_game1/audio/z1c1-2.mp3',
        volume: 1,
      },
      // text: {
      //   text: 'Siedź prosto przy komputerze.',
      //   pos: {
      //     y: 201,
      //     x: 835 - 175,
      //   },
      //   width: 600,
      //   background: '#f79646',
      //   cssStyle: { 'border-radius': '30px', border: 'solid 5px #c27537' },
      // },
    },
    {
      pos: {
        y: 270,
        x: 1453,
      },
      width: 74,
      height: 74,
      background: 'transparent',
      // cssStyle: { 'border-radius': '30px', border: 'solid 5px #758c42' },
      audio: {
        src: 'games/page001_game1/audio/z1c1-3.mp3',
        volume: 1,
      },
      // text: {
      //   text: 'Wykonuj polecenia nauczyciela.',
      //   pos: {
      //     y: 360,
      //     x: 1400,
      //   },
      //   width: 500,
      //   background: '#9bbb59',
      //   cssStyle: { 'border-radius': '30px', border: 'solid 5px #758c42' },
      // },
    },
    //
    {
      pos: {
        y: 947,
        x: 1453,
      },
      width: 74,
      height: 74,
      background: 'transparent',
      // cssStyle: { 'border-radius': '30px', border: 'solid 5px #9e413f' },
      audio: {
        src: 'games/page001_game1/audio/z1c1-6.mp3',
        volume: 1,
      },
      // text: {
      //   text: 'Nie rozłączaj przewodów komputerowych.',
      //   pos: {
      //     y: 655,
      //     x: 25,
      //   },
      //   width: 500,
      //   background: '#c0504d',
      //   cssStyle: { 'border-radius': '30px', border: 'solid 5px #9e413f' },
      // },
    },
    {
      pos: {
        y: 947,
        x: 1080,
      },
      width: 74,
      height: 74,
      background: 'transparent',
      // cssStyle: { 'border-radius': '30px', border: 'solid 5px #5e4977' },
      audio: {
        src: 'games/page001_game1/audio/z1c1-5.mp3',
        volume: 1,
      },
      // text: {
      //   text: 'Nie jedz i nie pij przy stanowisku komputerowym.',
      //   pos: {
      //     y: 871,
      //     x: 835 - 175,
      //   },
      //   width: 600,
      //   background: '#8064a2',
      //   cssStyle: { 'border-radius': '30px', border: 'solid 5px #5e4977' },
      // },
    },
    {
      pos: {
        y: 947,
        x: 705,
      },
      width: 74,
      height: 74,
      background: 'transparent',
      // cssStyle: { 'border-radius': '30px', border: 'solid 5px #377f92' },
      audio: {
        src: 'games/page001_game1/audio/z1c1-4.mp3',
        volume: 1,
      },
      // text: {
      //   text: 'Po zakończeniu zajęć komputerowych pozostaw porządek w pracowni.',
      //   pos: {
      //     y: 635,
      //     x: 1400,
      //   },
      //   width: 500,
      //   background: '#4bacc6',
      //   cssStyle: { 'border-radius': '30px', border: 'solid 5px #377f92' },
      // },
    },
  ],
  images: [
    {
      pos: {
        y: 277,
        x: 708,
      },
      src: 'games/page001_game1/img/des.png',
      close: true,
      width: 371,
      height: 348,
      background: 'red',
    },
    {
      pos: {
        y: 277,
        x: 1082,
      },
      src: 'games/page001_game1/img/des.png',
      close: true,
      width: 371,
      height: 348,
    },
    {
      pos: {
        y: 277,
        x: 1456,
      },
      src: 'games/page001_game1/img/des.png',
      close: true,
      width: 371,
      height: 348,
    },
    //
    {
      pos: {
        y: 679,
        x: 708,
      },
      src: 'games/page001_game1/img/des.png',
      close: true,
      width: 371,
      height: 348,
      background: 'red',
    },
    {
      pos: {
        y: 679,
        x: 1082,
      },
      src: 'games/page001_game1/img/des.png',
      close: true,
      width: 371,
      height: 348,
    },
    {
      pos: {
        y: 679,
        x: 1456,
      },
      src: 'games/page001_game1/img/des.png',
      close: true,
      width: 371,
      height: 348,
    },
  ],
  // mbAudioItemData: [
  //   {
  //     src: 'audio/test/test.mp3',
  //     audioConfig: {
  //       autoplay: false,
  //       loop: false,
  //       volume: 1,
  //     },
  //     iconConfig: {
  //       fill: 'none',
  //     },
  //     pos: {
  //       y: 0,
  //       x: 0,
  //     },
  //   },
  // ],
};

export default elements;
